import Loading from 'components/Loading';
import UserContext from 'contexts/user';
import { Component, PropsWithChildren, useContext } from 'react';
import { Route } from 'react-router';
import PrivateRoute from '../PrivateRoute';
type AdminRouteProps = {
  component: (props: any) => JSX.Element;
};
const AdminRoute = ({
  component,
  ...rest
}: PropsWithChildren<Route['props'] & AdminRouteProps>) => {
  const { user, fetching } = useContext(UserContext);
  if (fetching) {
    return <Loading text="Loading" />;
  }
  let isAdmin = !user || user.role === 'admin';
  return (
    <PrivateRoute
      checks={[isAdmin]}
      component={component}
      errorMessage={`You don't have access to that page`}
      redirectTo="/"
      {...rest}
    />
  );
};

export default AdminRoute;
